import { useMediaDevices } from '../hooks/use-media-devices';
import { MediaDevicesContext } from './media-devices-context';

export const MediaDevicesProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const mediaDevices = useMediaDevices();

  return (
    <MediaDevicesContext.Provider value={mediaDevices}>
      {children}
    </MediaDevicesContext.Provider>
  );
};
